import {ActionCodeColor} from "../shared/models/action-code-color";

export class WeekPlanningSetting {
  defaultDateRange: number;
  drivingTimeHours: number;
  drivingTimeMinutes: number;
  defaultDateFromRange: number = 0;
  fontSize: string;
}

export interface TmsActionCodeColorSetting {
  enabled: boolean;
  actionColors: ActionCodeColor[];
}

export interface TruckFilters {
  truckType: string;
  truckSubType: string;
}

export class PlanningSetting{
  captionLang: string = "ENU";
}

export class GeneralSetting{
  autoCloseSignalRConnectionWarning: boolean = false;
  moveToPoolAllowedAddresses: string;
  orderlineReuseStatus: number;
  containerReuseEnabled: boolean;
  enableReuseSummary: boolean;
  closeTransportOrderOnOrderlinesDock: boolean;
  checkContainerNumber: boolean;
  useRetourRemarks: boolean;
  disableAutomaticDockPaneOpening: boolean;
  useContainerStatuses: boolean;
  defaultPlanningGroupes: string;
  disableTOSelectionModal: boolean;
  showInitialDateInQuickFilter: boolean;
  manageFileReservation: boolean;
  useBoardComputerStatuses: boolean;
  enableAutocomplete: boolean;
  locationRequired: boolean;
  loadingMetersPb: boolean;
  palletPlacesPb: boolean;
  revenueTotalsPb: boolean;
  useContainers: boolean;
  useTrailers: boolean;
  useChassis: boolean;
  useChassisRightDock: boolean;
  sharedPlanningGroupChassisDock: string;
  stackerSites: string;
  considerRelatedCoupleOrderLines: boolean = false;
  forceSelectPlanningGroupOnPBScreen: boolean;
  forceSelectPlanningGroupOnDepotScreens: boolean;
  validatePlanningBlocksDataOnSelection: boolean;
}
